'use client'

import ConsultationRequestFormProvider, {
  ConsultationRequestFormProps,
} from '@/features/consultations/request/ConsultationRequestFormProvider'
import ConsultationRequestForm from '@/features/consultations/request/ConsultationRequestForm'

type Props = {
  providerProps: ConsultationRequestFormProps
}

export default function ConsultationRequestFormContainer({
  providerProps,
}: Props) {
  return (
    <ConsultationRequestFormProvider {...providerProps}>
      <ConsultationRequestForm
        session={providerProps.session}
        profile={providerProps.initialProfile}
        profileStatus={providerProps.profileStatus}
        availableSlots={providerProps.availableSlots}
      />
    </ConsultationRequestFormProvider>
  )
}
